// Autogenerated file, DO NOT MODIFY or it will be overwritten;
import type { SVGProps } from 'react';

import { forwardRef } from '@chakra-ui/react';

import { Icon, type IconProps } from '../Icon';

const Svg = (props: SVGProps<SVGSVGElement>) => (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    width="1em"
    height="1em"
    fill="none"
    viewBox="0 0 21 20"
    {...props}
  >
    <path
      stroke="#6F7881"
      strokeLinecap="round"
      strokeLinejoin="round"
      strokeWidth={1.5}
      d="M18.8333 7.44281C18.8333 6.93796 18.8333 6.68554 18.7335 6.56865 18.6468 6.46723 18.5169 6.41341 18.3839 6.42387 18.2307 6.43593 18.0522 6.61442 17.6952 6.9714L14.6666 10 17.6952 13.0286C18.0522 13.3856 18.2307 13.5641 18.3839 13.5761 18.5169 13.5866 18.6468 13.5328 18.7335 13.4313 18.8333 13.3145 18.8333 13.062 18.8333 12.5572V7.44281ZM2.16663 8.16666C2.16663 6.76653 2.16663 6.06647 2.43911 5.53169 2.67879 5.06128 3.06124 4.67883 3.53165 4.43915 4.06643 4.16666 4.76649 4.16666 6.16663 4.16666H10.6666C12.0668 4.16666 12.7668 4.16666 13.3016 4.43915 13.772 4.67883 14.1545 5.06128 14.3941 5.53169 14.6666 6.06647 14.6666 6.76653 14.6666 8.16666V11.8333C14.6666 13.2335 14.6666 13.9335 14.3941 14.4683 14.1545 14.9387 13.772 15.3212 13.3016 15.5608 12.7668 15.8333 12.0668 15.8333 10.6666 15.8333H6.16663C4.76649 15.8333 4.06643 15.8333 3.53165 15.5608 3.06124 15.3212 2.67879 14.9387 2.43911 14.4683 2.16663 13.9335 2.16663 13.2335 2.16663 11.8333V8.16666Z"
    />
  </svg>
);
const IconVideo = forwardRef((props: Omit<IconProps, 'icon'>, ref) => {
  return <Icon ref={ref} icon={Svg} {...props} />;
});
export default IconVideo;
